import React, { Component } from 'react'

import ClearedSubmissionListTable from './ClearedSubmissionsListTable';

import ProductChoice from '../../routes/Submissions/ProductChoice'
import SubmissionListFeed from './SubmissionListFeed'

import isUnderwriter from '../../utils/is-underwriter'

import { API_GATEWAY_NAME, API } from '../../../amplify'

import './submissions-home.scss'


class SubmissionsHome extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isUnderwriter: false,
      clearedSubmissions: [],
      clearedSubmissionLoading: false
    }
  }

  async componentWillMount() {
    const _isUnderwriter = await isUnderwriter()
    this.setState({ isUnderwriter: _isUnderwriter })
    if (_isUnderwriter) this.fetchClearedSubmissions()
  }

  fetchClearedSubmissions = async () => {
    this.setState({ clearedSubmissionLoading: true })
    const { data } = await API.get(API_GATEWAY_NAME, '/cleared-submissions')
    this.setState({ clearedSubmissions: data, clearedSubmissionLoading: false })
  }

  render() {
    const { isUnderwriter, clearedSubmissions, clearedSubmissionLoading } = this.state
    const { brokerageName, getQuotePreClearedSubmission, getDownloadQuoteSubmission, getDownloadQuoteSpecimenSubmission, user } = this.props
    return (
      <div className="container-fluid">
        <ClearedSubmissionListTable isUnderwriter={isUnderwriter} data={clearedSubmissions} loading={clearedSubmissionLoading} getQuotePreClearedSubmission={getQuotePreClearedSubmission} />
        <ProductChoice />
        <div className="submissions-list" id="submissionsHome">
          <h1>Submissions for {isUnderwriter ? 'Argo Group' : brokerageName}</h1>
          <SubmissionListFeed isUnderwriter={isUnderwriter} fetchClearedSubmissions={this.fetchClearedSubmissions} getDownloadQuoteSubmission={getDownloadQuoteSubmission} getDownloadQuoteSpecimenSubmission={getDownloadQuoteSpecimenSubmission} />
        </div>
      </div>
    )
  }
}

export default SubmissionsHome
